import { configureStore } from "@reduxjs/toolkit";
import jobBatchesReducer from "./jobBatchesSlice";
import authReducer from "./authSlice";

export const store = configureStore({
  reducer: {
    jobBatches: jobBatchesReducer,
    auth: authReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ["persist/PERSIST"],
      },
    }),
});
